import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	width: 100%;
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	gap: 0.6em;
	margin-bottom: 1em;

	.chips {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		gap: 0.6em;
	}

	.chip {
		display: flex;
		align-items: center;
		gap: 0.5em;
		padding: 0.4em 0.5em 0.4em 0.9em;
		border-radius: 2em;
		background-color: ${vars.colorBackground};
		border: 0.01em solid ${vars.colorBackgroundBorder};
		font-size: 0.85em;
		color: ${vars.colorText};

		.chip-label {
			white-space: nowrap;
		}

		.chip-remove {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 1.4em;
			height: 1.4em;
			border: 0;
			border-radius: 50%;
			background-color: transparent;
			color: ${vars.colorContrast};
			font-size: 1.1em;
			line-height: 1;
			cursor: pointer;
			padding: 0;

			&:hover {
				background-color: ${vars.colorBackgroundContrastDark};
			}
		}
	}

	.clear-all {
		border: 0;
		background: none;
		padding: 0;
		font-size: 0.85em;
		color: ${vars.colorContrast};
		text-decoration: underline;
		cursor: pointer;
		white-space: nowrap;

		&:hover {
			text-decoration: none;
		}
	}

	@media all and (max-width: ${vars.tabletS}) {
		.chip {
			font-size: 0.8em;
		}
	}
`;
